<template>
  <img
    v-if="firmId === 'fn' || firmId === 'leelee'"
    class="footer-counsel-logo"
    :src="GCSA_LEGAL_COUNSEL_COVER[firmId]"
    alt=""
    width="80"
    height="80"
    decoding="async"
  />
  <svg
    v-else
    class="footer-counsel-logo"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <template v-if="firmId === 'pmt'">
      <path
        d="M50.0967 27.4268H46.4844C45.512 27.4268 45.0957 27.8438 45.0957 29.2793V50.1191C45.0957 51.2304 45.1883 52.1104 46.4385 52.1104H50.0508V56H33.5645V52.1104H37.7324C38.8434 52.1102 38.9365 51.1377 38.9365 50.1191V28.6777L28.4238 56H25.46L21.0146 42.6162C22.6972 42.6316 26.2281 42.5518 26.8955 42.1074C27.0438 42.6632 27.6057 44.0053 27.8682 44.6074C28.177 43.6193 29.1372 41.3937 30.5078 40.3936C32.2212 39.1432 34.2587 37.2909 34.2588 32.6602C34.2588 31.7803 33.8887 29.9276 33.8887 29.2793C33.8887 28.7606 35.4323 25.5436 36.2041 24H50.0967V27.4268ZM77.8359 35.9941H74.4092C74.3629 34.8365 74.0481 32.1047 73.1592 30.4375C72.0477 28.3536 69.7319 27.8438 69.1299 27.8438H67.7412C67.0003 27.8438 66.6758 28.1215 66.6758 28.6309V50.2109C66.6758 51.1371 67.4167 52.1104 68.1113 52.1104H71.6309V56H55.5615V52.1104H59.2656C60.3771 52.1104 60.5625 51.137 60.5625 50.4424V28.3535C60.5625 27.7052 60.2386 27.4268 59.5439 27.4268H52.7832V24H77.8359V35.9941ZM22.9131 24.0469C25.2285 24.0469 33.1472 24.9733 33.1475 32.7529C33.1475 40.533 25.136 41.3203 22.9131 41.3203H20.4121L19.1152 37.8936C19.424 37.8936 20.3661 37.8939 22.0332 37.5234C24.1171 37.0604 25.9227 35.8562 25.9229 32.3369C25.9229 28.6323 22.8208 27.3819 21.0146 27.3818H14.8086V49.5176C14.8086 50.7215 14.9478 52.1101 16.0127 52.1104H20.2275V55.9541H3V52.1104H6.10254C7.67702 52.1104 8.09372 50.6753 8.09375 49.5176V29.1416C8.09375 28.1692 7.30693 27.382 6.14941 27.3818H3.09277V24.0469H22.9131Z"
        fill="#891316"
      />
    </template>

    <template v-else>
      <path
        d="M56.3584 19C64.8806 19 72.6278 25.2115 72.6279 33.9111C72.6279 42.6108 63.5734 48.825 56.2939 48.8252H44.5752V60.5439H32.6797V50.4238C34.3368 50.4238 38.7142 50.1585 42.0898 48.4707C45.9959 46.5177 48.4814 43.6761 49.3691 42.0781H54.1631C58.9569 42.0781 61.6201 37.6394 61.6201 33.7334C61.6199 29.4725 58.2465 26.0996 54.1631 26.0996H49.9023C47.9139 22.2648 43.1021 19.6512 40.9121 19H56.3584ZM42.2676 42.6113H32.6797V25.5674H42.2676V42.6113Z"
        fill="#888888"
      />
      <path
        d="M20.2508 60.3686V25.9244H28.5955C35.6975 25.9244 38.8933 30.3631 38.8933 34.2691C38.8933 38.1752 35.5199 41.9037 31.2588 41.9037H26.9976L22.5589 49.0056H32.5016C41.9116 49.0056 50.0788 40.8384 50.0788 33.5589C50.0788 26.2795 43.5096 19 32.5016 19H8V60.3686H20.2508Z"
        fill="#0D3C96"
      />
    </template>
  </svg>
</template>

<script setup lang="ts">
import type { GcsaLegalCounselFirmId } from '../consts/gcsaLegalCounselContent';
import { GCSA_LEGAL_COUNSEL_COVER } from '../consts/gcsaLegalCounselAssets';

defineProps<{
  firmId: GcsaLegalCounselFirmId;
}>();
</script>
